// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"5f152b07","425":"ea4b58cd","510":"394fde20","532":"414d80e7","633":"9246f6bc","634":"655f4219","922":"ccf16d1e","937":"01bed30d","972":"4ed9caaf"}[chunkId] + ".chunk.js";
};